import { render, staticRenderFns } from "./WebSetting.vue?vue&type=template&id=72c36a2b&scoped=true"
import script from "./WebSetting.vue?vue&type=script&lang=js"
export * from "./WebSetting.vue?vue&type=script&lang=js"
import style0 from "./WebSetting.vue?vue&type=style&index=0&id=72c36a2b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c36a2b",
  null
  
)

export default component.exports